import { List, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Repeat } from "lib/@components/repeat"
import { NoResults } from "lib/@components/no-results/no-results"
import { MacroHistoryItem } from "./macro-history-item"

export function MacroHistoryList({ history = [], currentVersion }) {
    const entries = buildEntries(history, currentVersion)

    return (
        <Stack spacing={1.25} data-cy="macro-history-section">
            <Typography variant="subtitle2">History</Typography>
            <If truthy={entries.length > 0}>
                <List disablePadding>
                    <Repeat list={entries} pass="entry" keyFn={historyKey} item={<MacroHistoryItem />} />
                </List>
                <Else>
                    <NoResults mt={0} width={220}>
                        No previous versions.
                    </NoResults>
                </Else>
            </If>
        </Stack>
    )

    function historyKey(entry, index) {
        return `${entry.version ?? "v"}-${entry.changedAt ?? index}`
    }
}

function buildEntries(history, currentVersion) {
    const entries = Array.isArray(history) ? [...history] : []
    entries.sort(compareHistory)

    if (!currentVersion || currentVersion < 1) {
        return entries
    }

    return entries
}

function compareHistory(left, right) {
    const leftVersion = Number(left?.version) || 0
    const rightVersion = Number(right?.version) || 0
    return rightVersion - leftVersion
}
